const routeLogs = () => '/logs';

export default routeLogs;